import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'ar-i18n';

class RakutenLoader extends React.Component {
    static propTypes = { className : PropTypes.string };

    render() {
        let parentClass = this.props.className || '';

        return (
            <div className={ `rakuten-loader ${parentClass}` }>
                <i className='rakuten-loader-indicator' />
                <span className='rakuten-loader-text'>{ i18n.gettext('Loading...') }</span>
            </div>
        );
    }
}

export default RakutenLoader;
